let cache

export const generateCache = (initialCache = {}) => {
  cache = initialCache
  return cache
}

export const getScriptSrc = (account, player) => `https://players.brightcove.net/${account}/${player}_default/index.min.js`

const createScript = (src) => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = src
  return script
}

const scriptIsInDom = (src) =>
  Array.prototype.slice
    .call(document.querySelectorAll('script'))
    .map((s) => s.src)
    .filter((s) => s === src).length

const playerScriptHasLoaded = (account, player) =>
  window.bc &&
  window.videojs &&
  Object.keys(window.videojs.players)
    .map((playerKey) => {
      const playerInstance = window.videojs.players[playerKey]
      const options = playerInstance ? playerInstance.options_ : {} // eslint-disable-line
      return {
        account: options['data-account'],
        player: options['data-player']
      }
    })
    .filter((p) => p.account === account && p.player === player).length

export const loadPlayer = (account, player) => {
  const src = getScriptSrc(account, player)

  cache = cache || generateCache()

  if (cache[src]) {
    return cache[src]
  }

  if (scriptIsInDom(src) && playerScriptHasLoaded(account, player)) {
    cache[src] = new Promise((resolve) => resolve())
    return cache[src]
  }

  const script = createScript(src)
  const loadPlayerPromise = new Promise((resolve, reject) => {
    script.onerror = reject
    script.onload = resolve
    return null
  })

  cache[src] = loadPlayerPromise
  document.head.appendChild(script)

  return cache[src]
}

export const createOrGetVideo = (account, player, videoNode) =>
  new Promise((resolve, reject) =>
    loadPlayer(account, player)
      .then(() => {
        window.bc(videoNode)
        const videoPlayer = window.videojs(videoNode)
        videoPlayer.ready(() => resolve(videoPlayer))
      })
      .catch((e) => reject(e))
  )

export const playVideo = (account, player, videoNode) =>
  createOrGetVideo(account, player, videoNode).then((video) => {
    video.play()
    return video
  })

export const pauseVideo = (account, player, videoNode) =>
  createOrGetVideo(account, player, videoNode).then((video) => {
    video.pause()
    return video
  })

export const hideControlBar = (container) => {
  const controlBar = container.querySelector('.vjs-control-bar')
  controlBar.style.setProperty('display', 'none')
}
